module.exports = __webpack_public_path__ + "static/media/check.f172617c.svg";